import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon, PhoneIcon } from "lucide-react";
import { company } from "../../data/navigation";
export function CtaSection() {
  return <section className="w-full bg-white pb-20 md:pb-28" data-id="element-83" data-mp="1d4vkpx2pq1li">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-84" data-mp="1d7i3ksv203j1">
        <div className="grid items-center gap-10 overflow-hidden rounded-3xl bg-lime p-8 md:p-14 lg:grid-cols-12" data-id="element-85" data-mp="1i4rru56pi95a">
          <div className="lg:col-span-7" data-id="element-86" data-mp="ki1cbyj66soe">
            <h2 className="text-4xl font-semibold leading-[1.05] tracking-tight text-ink md:text-[56px]" data-id="element-87" data-mp="kj2mm0sd3b52">
              Un projet ? Une urgence ?
            </h2>
            <p className="mt-5 max-w-lg text-lg leading-relaxed text-ink/75" data-id="element-88" data-mp="udcj9uoc6vll">
              Devis gratuit sous 48 h, visite technique offerte. Pour les urgences,
              un technicien chez vous en moins de 2 heures.
            </p>
          </div>
          <div className="flex flex-col gap-3 lg:col-span-5 lg:items-end" data-id="element-89" data-mp="29vebl9cfdqin">
            <Link to="/contact" className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-ink px-8 py-4 font-medium text-white transition-colors duration-150 ease-out hover:bg-ink-soft lg:w-72" data-id="element-90" data-mp="29xiq0l7ya7x6">
              Demander un devis
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-91" data-mp="3n4sz9suxqeg7" />
            </Link>
            <a href={company.phoneHref} className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-ink/30 px-8 py-4 font-medium text-ink transition-colors duration-150 ease-out hover:border-ink lg:w-72" data-id="element-92" data-mp="3j3fqpb0gjx5l">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-93" data-mp="34cqcs0vm43y1" />
              {company.phone}
            </a>
          </div>
        </div>
      </div>
    </section>;
}